import FormHeader from  './form-header'
import DbSoftTree from  './db-soft-tree'
import DbSoftSelect from  './db-soft-select'
import HostPanelTree from  './host-panel-tree'
import ProjectSelect from  './project-select'
import UserGroupTransfer from  './user-group-transfer'
import UserRoleTransfer from  './user-role-transfer'
import UserInfoPanel from  './user-info-panel'
import UserTransfer from  './user-transfer'
import BaseTree from "./base-tree";
import EnvItem from "./env-item";
import WebsocketTerminal from "./websocket-terminal";

const version = '__VERSION__';
const components = {
  FormHeader,
  DbSoftTree,
  DbSoftSelect,
  HostPanelTree,
  ProjectSelect,
  UserGroupTransfer,
  UserRoleTransfer,
  UserInfoPanel,
  UserTransfer,
  BaseTree,
  EnvItem,
  WebsocketTerminal,

}

// function install (Vue) {
//   Object.keys(components).forEach((key) => {
//     Vue.use(components[key]);
//   });
// }


// if (typeof window !== 'undefined' && window.Vue) install(window.Vue);

export {
  FormHeader,
  DbSoftTree,
  DbSoftSelect,
  HostPanelTree,
  ProjectSelect,
  UserGroupTransfer,
  UserRoleTransfer,
  UserInfoPanel,
  UserTransfer,
  BaseTree,
  EnvItem,
  WebsocketTerminal,
}
export default {
  ...components
}



// WEBPACK FOOTER //
// ./src/omnis-business/index.js